/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeownershipFinancing = {
    Partner: 'partner',
    Own: 'own',
    Cash: 'cash'
} as const;
export type HomeownershipFinancing = typeof HomeownershipFinancing[keyof typeof HomeownershipFinancing];


export function HomeownershipFinancingFromJSON(json: any): HomeownershipFinancing {
    return HomeownershipFinancingFromJSONTyped(json, false);
}

export function HomeownershipFinancingFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipFinancing {
    return json as HomeownershipFinancing;
}

export function HomeownershipFinancingToJSON(value?: HomeownershipFinancing | null): any {
    return value as any;
}

